module.exports = __webpack_public_path__ + "img/dne-pay.1c5e573c.svg";